<script setup>
import {computed, getCurrentInstance, onMounted, ref} from "vue";
import _ from "lodash";
import KSASecondaryButton from "@/components/ui-components/button/KSASecondaryButton.vue";
import {useAlertStore} from "@/stores/alertStore";
import {usePageLoadingStore} from "@/stores/pageLoading";
import adminCorpInfoService from "@/pages/admin/services/corporation/adminCorpInfoService";
import KSATextButton from "@/components/ui-components/button/KSATextButton.vue";
import {useRouter} from "vue-router";
import MyPageResumeModal from "@/pages/user/components/modal/mypage/MyPageResumeModal.vue";
import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";
const { $alert, $confirm } = useAlertStore();

const router = useRouter()
const loadingStore = usePageLoadingStore()
const { $applyStateGb, $number, $pageListBoardNo, $yyyymmddHHmmss } = getCurrentInstance().appContext.config.globalProperties;

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
});

const user = computed(() => props.user || {});

const list = ref([]);
const applyStateGb = ref($applyStateGb);

const userMatchingResumeModal = ref(null);

const applyStateGbsListRef = ref(null);

const searchOpen = ref(true);

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);


// 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색)
const searchDurationTypeGroup = ref([
  { label:'모든 기간', value: 'all' },
  { label:'기간 검색', value: 'term' },
]);

// 검색조건 - 페이지 크기
const pageSizeGroup = ref([
  { label:'10개씩 보기', value: '10' },
  { label:'30개씩 보기', value: '30' },
  { label:'50개씩 보기', value: '50' },
  { label:'100개씩 보기', value: '100' },
]);

const searchInput = ref({ // 채용 진행 현황 tab 검색조건
  searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
  searchCorpName: '',
  searchDurationType: 'all',
  startYmd: '',
  endYmd: '',
});

const retrieveList = async () => {
  let paramObj = {
    userId: user.value.userId,
    startYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.startYmd,
    endYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.endYmd,
    searchApplyStateGb: _.map(searchInput.value.searchApplyStateGbs).join(','),
    searchCorpName: searchInput.value.searchCorpName,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  //loaded.value = false;
  adminCorpInfoService.retrieveApplicantListPagingByUserId(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        //loaded.value = true;
        //console.log(res);
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        } else {
        }
      }).catch( (res) =>  {
    console.log(res);
    loadingStore.loading = false;
    //loaded.value = true;
  });
}

// 입사지원 상태변경
const onClickApplyStateGb = async (corpId, resumeId, stateGb) => {
  if (stateGb === "01") {
    stateGb = "02"
  }
  const ok = await $confirm(["지원을 취소 하시겠습니까?", "'지원취소'로 상태가 변경됩니다."], "지원 취소");
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      corpId: corpId,
      resumeId: resumeId,
      applyStateGb: stateGb,
    }
    mypageCorpInfoService.updateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            $alert("변경하였습니다.");
            //$toast('', "삭제를 하였습니다.")

            retrieveList();
          } else {
            $alert("변경을 실패하였습니다.");
            console.log(res);
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          $alert("변경을 실패하였습니다.");
        });
  }
}

// 이력서 보기
const onClickViewResume = async (resumeId) => {
  userMatchingResumeModal.value.init(false);
  userMatchingResumeModal.value.retrieveApplicantResume(resumeId, 0);
  userMatchingResumeModal.value.show();
}

// 페이지 선택
const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

// 검색조건 - 페이지 크기 변경 이벤트
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  retrieveList();
}

// 검색조건 - '초기화' 버튼
const clearSearchInput = () => {
  searchInput.value = {
    searchApplyStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchCorpName: '',
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
  }
  applyStateGbsListRef.value.initOptions();
}

// 검색조건 - '검색' 버튼
const onClickSearch = () => {
  currentPage.value = 1;
  retrieveList();
}

onMounted(() => {
  retrieveList();
})
</script>
<template>
  <!-- s: 검색 -->
  <div class="filter-wrap" :class="{'open': searchOpen}">
    <p @click="searchOpen = !searchOpen">검색</p>
    <div class="filter">
      <dl>
        <dt style="display:block;">상태</dt>
        <dd>
          <KSACheckBoxGroup
              ref="applyStateGbsListRef"
              className="mr-md"
              name="applyStateGbsList"
              v-model="searchInput.searchApplyStateGbs"
              :options="applyStateGb"
          />
        </dd>
      </dl>
      <dl>
        <dt>입사지원일</dt>
        <dd class="text-box">
          <div class="grid">
            <template v-for="group in searchDurationTypeGroup" key="item.value" >
              <KSARadioButton class="mr-md" name="searchDurationGb3" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
            </template>
            <div style="display: inline-block;" v-show="searchInput.searchDurationType !== 'all'">
              <KSADatepickerTerms
                  :startDate="searchInput.startYmd"
                  :endDate="searchInput.endYmd"
                  @update:startDate="(value)=> searchInput.startYmd = value"
                  @update:endDate="(value)=> searchInput.endYmd = value"
              />
            </div>
          </div>
        </dd>
      </dl>
      <dl>
        <dt>기업명</dt>
        <dd>
          <KSAInput class="text-box" v-model="searchInput.searchCorpName" placeholder="기업명을 입력해 주세요." />
        </dd>
      </dl>
      <div class="btn-wrap">
        <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
        <KSAPrimaryButton text="검색" @click="onClickSearch" />
      </div>
    </div>
  </div>
  <!-- e: 검색 -->
  <div class="list-top">
    <p>전체 <span>{{ $number(totalCount)}}</span>건</p>
    <div>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
  </div>
  <div class="table-form">
    <table class="horizontal" v-if="list !== null">
      <tr>
        <th>NO</th>
        <th>기업명</th>
        <th>이력서보기</th>
        <th>관심 카테고리</th>
        <th>입사 지원일</th>
        <th>상태</th>
        <th>상태변경</th>
      </tr>
      <tr v-for="member in list">
        <td>{{ member.boardNo }}</td>
        <td class="clickable blue text-overflow">
          <span @click="router.push({name: 'CorporationDetail', params:{id: member.corpId}})">{{member.corpName}}</span>
        </td>
        <td class="clickable blue"><span @click="onClickViewResume(member.resumeId)">이력서 보기</span></td>
        <td>{{ member.interests }}</td>
        <td>{{ $yyyymmddHHmmss(member.createDate) }}</td>
        <td>
          <span v-if="member.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',member.applyStateGb) }}</span>
          <span v-else-if="member.applyStateGb === '03' || member.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',member.applyStateGb) }}</span>
          <span v-else-if="member.applyStateGb === '04' || member.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',member.applyStateGb) }}</span>
          <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',member.applyStateGb) }}</span>
        </td>
        <td>
          <div v-if="member.applyStateGb === '01'">
            <KSATextButton class="clickable black_button" text="지원취소" @click="onClickApplyStateGb(member.corpId, member.resumeId, '02')"/>
          </div>
          <div v-else>
            -
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="result-none" v-if="list.length === 0">
    입사지원 내역이 없습니다.
  </div>
  <Paginate
      v-if="list.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
  />
  <MyPageResumeModal ref="userMatchingResumeModal"/>
</template>
<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";


.blue {
  color: $blue_color;
}

.table-form {
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>